﻿import { Vimeo } from "../Video/Types/vimeo";

const videoBackground = () => {
  const reducedMotion =
    window.matchMedia("(prefers-reduced-motion: reduce)")?.matches ?? false;

  if (reducedMotion) {
    console.info(
      "Reduce motion preference enabled, not loading video, leaving fallback image displayed."
    );
    return;
  }

  if (!Vimeo) {
    console.error("Vimeo is not loaded");
  } else {
    const components = document.querySelectorAll("[data-js-background-video]");

    if (!components?.length) {
      return;
    }

    for (const component of components) {
      initializeVideoComponent(component);
    }
  }
};

const initializeVideoComponent = (component: Element) => {
  const video = component.querySelector("div[data-background-video-url]") as HTMLElement;

  if (!video) {
    console.error("A background video component is missing a video element.");
    return;
  }

  const options = {
    url: video.getAttribute("data-background-video-url"),
    dnt: true,
    background: true,
  };

  const videoPlayer = new Vimeo.Player(video, options);
};

videoBackground();
